const dayjs = require('dayjs')
const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone')
const customParseFormat = require('dayjs/plugin/customParseFormat')

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(customParseFormat)


function returnDayjsWrapperObject(dateStr, formatOfDateStr) {
    return dayjs(dateStr, formatOfDateStr)
}

function formatCurrentTimeAccordingToTimezone(timezone, formatString) {
    return dayjs(Date.now()).tz(timezone).format(formatString)
}


function manipulateAndThenFormatCurrentTimeAccordingToTimezone(timezone, formatString, quantityToAddOrSubtract, unitsAddedOrSubtracted) {
    return dayjs(Date.now()).tz(timezone).add(quantityToAddOrSubtract, unitsAddedOrSubtracted).format(formatString)
}


function getTimeAccordingToATimezone(timeString, formatString, timezone) {
    return dayjs(timeString, formatString).tz(timezone, true)    //remove true, if you don't want timestring to be converted twice
}


function getCurrentTimeInATimezone(timezone) {
    return dayjs().tz(timezone)
}


function getDifferenceBetweenTimes(time1, time2, quantity) {
    return time2.diff(time1, quantity)
}


function formatDateString(dateStr, inputFormat, newFormat) {
    return dayjs(dateStr, inputFormat).format(newFormat)
}

function sortDates(datesAsStringsInsideAnArray) {
    return datesAsStringsInsideAnArray.sort((a, b) => (dayjs(a).isAfter(dayjs(b)) ? 1 : -1))
}

function formatDayJsObject(dayjsObj, format) {
    return dayjs(dayjsObj).format(format)
}

function convertToUnixTime(timeStr, formatStr = "DD/MM") {

    let newTimeStr
    if (formatStr.includes("DD/MM") || formatStr.includes("DD-MM")) {
        newTimeStr = timeStr.substring(3, 5) + "/" + timeStr.substring(0, 2) + timeStr.substring(5, 19)
    } else {
        newTimeStr = timeStr
    }

    return dayjs(newTimeStr).unix() * 1000 //JS representation is *1000
}

function unixToHumanDate(unixTimestamp, formatString) {
    return dayjs(unixTimestamp).format(formatString)
}

function getCurrentTimeInUnixEpochAccordingToATimezone(timezone) {
    return dayjs().tz(timezone).unix() * 1000
}


module.exports = {
    returnDayjsWrapperObject,
    formatDateString,
    formatCurrentTimeAccordingToTimezone,
    manipulateAndThenFormatCurrentTimeAccordingToTimezone,
    getTimeAccordingToATimezone,
    getCurrentTimeInATimezone,
    getDifferenceBetweenTimes,
    sortDates,
    formatDayJsObject,
    convertToUnixTime,
    unixToHumanDate,
    getCurrentTimeInUnixEpochAccordingToATimezone
}